export default __webpack_public_path__ + "static/media/dallasCowboys@2x.5a04b4a1.jpg";